import { deleteRegion } from "../../../../../actions/Utilities/Region";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "../../../../../components/toastNotification";

const useDeleteRegion = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation((ids) => deleteRegion(ids), {
    onSuccess: (res) => {
      queryClient.invalidateQueries(["GetRegion"]);
      toast.fire("Success", "Region has been deactivated successfully", "success");
    },
    onError: (error) => {
      toast.fire(
        "Failed",
        "Server Error: Cannot deactivate Region",
        "error"
      );
    },
  });

  return mutate;
};
export default useDeleteRegion;
